import React, { ReactNode, useCallback, useMemo } from 'react';
import BackTop from 'antd/es/back-top';
import 'antd/es/back-top/style/index.css';
import { Helmet } from 'react-helmet';
import cx from 'clsx';

import { IconToTop } from '@/assets';
import { TrialModal } from '@/components';
import GA from '@/utils/GoogleAnalytics';
import metaTitle from '@/consts/metaTitle';

import { Sidebar } from './components';
import style from './index.module.css';
import { useLocation } from 'react-router-dom';
import { getCurrentAddressInfo } from '@/utils';
import { useUpdateCurrentAddressInfo } from '@/hooks';

type DesktopFrameProps = {
  children: ReactNode;
};

const HideSideBarRoutes = [
  '/download',
  '/editor',
  '/connect',
  '/official-invitation',
  '/sns-bind',
  '/claim',
  '/link',
  '/hi-thirdparty',
];

// const HideFooterRoutes = ['/hi', '/official-invitation/'];
// const HideReferralCodeBtnRoutes = ['/official-invitation/', '/connect'];
const RightFloatBtnRoutes = ['/whales'];

export const DesktopFrame = ({ children }: DesktopFrameProps) => {
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const router = useLocation();
  const { hasShownTrialModal, userInfo, isVerified } = getCurrentAddressInfo() || {};
  const update = useUpdateCurrentAddressInfo();

  const handleCloseTrialModal = useCallback(() => {
    update({ hasShownTrialModal: true });
  }, [update]);

  const hideSideBar = useMemo(
    () => HideSideBarRoutes.some(e => router.pathname.startsWith(e)),
    [router.pathname],
  );

  // const hideFooter = useMemo(
  //   () => HideFooterRoutes.some(e => router.pathname.startsWith(e)),
  //   [router.pathname],
  // );

  // const HideReferralCodeBtn = useMemo(
  //   () => HideReferralCodeBtnRoutes.some(e => router.pathname.startsWith(e)),
  //   [router.pathname],
  // );

  const alignRightBtn = useMemo(
    () => RightFloatBtnRoutes.some(e => router.pathname.startsWith(e)),
    [router.pathname],
  );

  return (
    <div className={style.container}>
      <Helmet>
        <title>{metaTitle.App.title}</title>
        {metaTitle.App.meta.map(v => (
          <meta name={v.name} content={v.content} key={v.name} />
        ))}
        <meta name="viewport" content="width=1150" />
      </Helmet>
      {typeof window !== 'undefined' ? GA.init() && <GA.RouteTracker /> : null}
      {hideSideBar ? null : <Sidebar />}
      <div className={style.main}>
        {hideSideBar ? children : <div className={style.content}>{children}</div>}
        {/* {hideFooter ? null : <Footer />} */}
      </div>
      {/* {HideReferralCodeBtn ? null : <ReferralCodeBtn />} */}
      <div className={cx(style.toTop, alignRightBtn && style.alignRight)}>
        <BackTop onClick={scrollToTop}>
          <IconToTop />
        </BackTop>
      </div>
      <TrialModal
        on={!!isVerified && !userInfo?.web3_id && !hasShownTrialModal}
        turnoff={handleCloseTrialModal}
      />
    </div>
  );
};

export default DesktopFrame;
